// src/useMetaPixel.js
import { useEffect } from 'react';
import { loadWhenIdle } from './utils/loadWhenIdle';   // ⬅️ adjust the path if needed

/**
 * React hook that injects and initialises the Meta/Facebook Pixel
 * **after** the first paint, so it never blocks LCP or INP.
 *
 * @param {string} pixelId – Your Meta Pixel ID (e.g. '992885382726061')
 */
const useMetaPixel = (pixelId) => {
  useEffect(() => {
    // Don’t run if no ID or the pixel is already present
    if (!pixelId || window.fbq) return;

    loadWhenIdle(() => {
      /* --- Standard Facebook Pixel bootstrap (unchanged) --- */
      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

      window.fbq('init', pixelId);
      window.fbq('track', 'PageView');
    });
  }, [pixelId]);
};

export default useMetaPixel;
